
import { NodeType, AgentType } from '../types';

export const NODE_LABELS: Record<NodeType, string> = {
  [NodeType.ENTRANCE]: 'Pagrindinis įėjimas',
  [NodeType.AMBULANCE_ENTRANCE]: 'GMP įvažiavimas',
  [NodeType.RECEPTION]: 'Registratūra',
  [NodeType.TRIAGE]: 'Triažas',
  [NodeType.WAITING]: 'Laukiamasis',
  [NodeType.EXAM_ROOM]: 'Apžiūros kabinetas',
  [NodeType.PROCEDURE_ROOM]: 'Procedūrinis kabinetas',
  [NodeType.UTILITY_ROOM]: 'Pagalbinės patalpos',
  [NodeType.ISOLATION_ROOM]: 'Izoliacinė palata',
  [NodeType.TRAUMA_BAY]: 'IT salė',
  [NodeType.RADIOLOGY]: 'Radiologiniai tyrimai',
  [NodeType.LABORATORY]: 'Laboratorija',
  [NodeType.PHARMACY]: 'Vaistinėlė',
  [NodeType.WARD]: 'Palata',
  [NodeType.HALLWAY]: 'Koridorius',
  [NodeType.STAFF_STATION]: 'Personalo postas',
  [NodeType.STAFF_REST]: 'Poilsio kambarys',
  [NodeType.WAYPOINT]: 'Kelio taškas',
  [NodeType.BED]: 'Lova',
  [NodeType.ELEVATOR]: 'Liftas',
  [NodeType.ARMCHAIRS]: 'Foteliai',
  [NodeType.VIP_ZONE]: 'VIP zona',
  [NodeType.SECURITY_POST]: 'Apsaugos postas',
  [NodeType.CONFERENCE_HALL]: 'Konferencijų salė',
  [NodeType.SOCIAL_ROOM]: 'Socialinė patalpa',
  [NodeType.WC]: 'WC',
  [NodeType.CALL_CENTER]: 'Skambučių centras',
  [NodeType.STATISTICS]: 'Statistika',
  [NodeType.TELEMEDICINE]: 'Telemedicina',
  [NodeType.ADMIN]: 'Administracija',
  [NodeType.CUSTOM]: 'PRITAIKOMA ZONA',
  [NodeType.CLOAKROOM]: 'Rūbinė',
  [NodeType.WASHING]: 'Pacientų prausimas',
  // Fix: Added missing label for DOOR node type
  [NodeType.DOOR]: 'Durys'
};

export const NODE_ABBREVIATIONS: Record<NodeType, string> = {
  [NodeType.ENTRANCE]: 'ĮĖJ',
  [NodeType.AMBULANCE_ENTRANCE]: 'GMP',
  [NodeType.RECEPTION]: 'RECP',
  [NodeType.TRIAGE]: 'TRG',
  [NodeType.WAITING]: 'LAUK',
  [NodeType.EXAM_ROOM]: 'APŽ',
  [NodeType.PROCEDURE_ROOM]: 'PROC',
  [NodeType.UTILITY_ROOM]: 'PAGALB',
  [NodeType.ISOLATION_ROOM]: 'ISO',
  [NodeType.TRAUMA_BAY]: 'IT',
  [NodeType.RADIOLOGY]: 'RAD',
  [NodeType.LABORATORY]: 'LAB',
  [NodeType.PHARMACY]: 'VAIST',
  [NodeType.WARD]: 'PAL',
  [NodeType.HALLWAY]: 'KOR',
  [NodeType.STAFF_STATION]: 'POST',
  [NodeType.STAFF_REST]: 'POILS',
  [NodeType.WAYPOINT]: 'WP',
  [NodeType.BED]: 'BED',
  [NodeType.ELEVATOR]: 'LIFT',
  [NodeType.ARMCHAIRS]: 'FOT',
  [NodeType.VIP_ZONE]: 'VIP',
  [NodeType.SECURITY_POST]: 'APS',
  [NodeType.CONFERENCE_HALL]: 'KONF',
  [NodeType.SOCIAL_ROOM]: 'SOC',
  [NodeType.WC]: 'WC',
  [NodeType.CALL_CENTER]: 'CALL',
  [NodeType.STATISTICS]: 'STAT',
  [NodeType.TELEMEDICINE]: 'TELE',
  [NodeType.ADMIN]: 'ADM',
  [NodeType.CUSTOM]: 'CUST',
  [NodeType.CLOAKROOM]: 'RŪB',
  [NodeType.WASHING]: 'PRAUS',
  // Fix: Added missing abbreviation for DOOR node type
  [NodeType.DOOR]: 'DUR'
};

export const AGENT_LABELS: Record<AgentType, string> = {
  [AgentType.PATIENT_WAL_IN]: 'Pacientas (savarankiškas)',
  [AgentType.PATIENT_TRAUMA]: 'Pacientas (Trauma)',
  [AgentType.PATIENT_STROKE]: 'Pacientas (Insultas)',
  [AgentType.PATIENT_EMS]: 'Pacientas (atvežtas GMP)',
  [AgentType.PATIENT_INFECTIOUS]: 'Pacientas (infekuotas)',
  [AgentType.COMPANION]: 'Lydintis asmuo',
  [AgentType.DOCTOR]: 'Gydytojas',
  [AgentType.NURSE]: 'Slaugytojas',
  [AgentType.NURSE_ASSISTANT]: 'Padėjėjas',
  [AgentType.SPECIALIST_TEAM]: 'Specialistų komanda'
};
